import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialDesignModule } from '../../../shared/material-design/material-design.module';
import { CopyFromProductComponent } from './copy-from-product/copy-from-product.component';
import { CopyToProductComponent } from './copy-to-product/copy-to-product.component';
import { CopyToComponent } from './copy-to/copy-to.component';
import { CopyVerticalComponent } from './copy-to/copy-vertical.component';
import { SearchProductsModule } from '../../../shared/search-products/search-products.module';
import { CopyHorizontalComponent } from './copy-to/copy-horizontal.component';
import { SharedModule } from '../../../shared/shared.module';

import { CardService } from '../card.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialDesignModule,
    SearchProductsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [
    CopyFromProductComponent,
    CopyToProductComponent,
    CopyVerticalComponent,
    CopyHorizontalComponent,
    CopyToComponent,
  ],
  providers: [
    CardService
  ],
  entryComponents: [
    CopyVerticalComponent,
    CopyHorizontalComponent
  ],
  exports: [
    CopyFromProductComponent,
    CopyToProductComponent,
    CopyToComponent
  ]
})
export class CopyConfigurationModule { }



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-configuration.module.ts